import { circIn } from "motion";
import eyeopening from "../images/eye-opening.DVsKLLaI_2w9dgH.webp";
import { motion } from "motion/react";

const AboutMe = () => {
  return (
    <div className="flex gap-x-6 mt-16">
      <div className="w-full p-0.5 bg-gradient-to-b from-[#272727] to-[#111111] rounded-[40px]">
        <div
          initial={{ scale: 0 }}
          animate={{ transition: { duration: 0.4, timing: circIn }, scale: 1 }}
          className="flex items-center w-full bg-[#0D0D0D] rounded-[40px] text-white p-10"
        >
          <div className="w-4/12 img-after">
            <img src={eyeopening} className="w-10/12 mx-auto" alt="image" />
          </div>
          <div className="w-8/12 px-6">
            <div className="text-5xl">
              What makes me
              <p className="pacifico-regular inline"> different</p> ?
            </div>
            <p className="text-lg mt-8 text-[#9CA3AF] tracking-wider">
              When you work with me, you're partnering with someone who is
              committed to bringing your vision to life with precision,
              pixel-perfection and flawless execution.
            </p>
            <button className="px-2 py-1 mt-8 border-[#272727] border-2 rounded-xl">
              <p className="text-lg px-3">View Resume</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
